module.exports = __webpack_public_path__ + "img/info2.2be29e38.png";